class AgricultureTurfShop extends HTMLElement {
    constructor() {
        super();
        this.agricultureTurfJsonData = null;
        this.uniqueCategories = [];
        this.elements = {};
        this.selectedData = {
            equipment_category: '',
            equipment_manufacturer: '',
            equipment_model_number: ''
        };
        this.initJsonData();
    }

    async initJsonData() {
        try {
            const json = await vehicleUtility.tsvTurfJSON();
            this.initVehicle(json);
        } catch (error) {
            console.error('Failed to load vehicle data:', error);
        }
    }

    initVehicle(json) {
        this.agricultureTurfJsonData = json;
        this.uniqueCategories = this.getUniqueCategories();
        this.cacheElements();
        this.bindEvents();

        const limitedSuggestions = this.uniqueCategories.slice(0, 3);

        const container = this.querySelector("[data-vehicle-suggestion]");
        const suggestionBox = this.querySelector(`[data-vehicle-suggestion-box]`);

        if (!container || !suggestionBox) return;

        container.innerHTML = '';

        limitedSuggestions.forEach(item => {
            const formattedText = item.replace(/\s?\|\s?/g, ' ');
            
            const li = this.createElement('li', formattedText, {
                'data-vehicle-value': '',
                'data-vehicle-model-value': item,
                class: 'block__vehicle-lookup-input-result-li'
            });

            li.addEventListener('click', (e) => {
                container.querySelectorAll("li").forEach((list) => {
                    list.classList.remove("selected");
                });
                e.target.classList.add("selected");
                let targetMakeModel = e.target.getAttribute("data-vehicle-model-value");
                var makeModelValue = e.target.textContent;

                this.selectedData.equipment_category = targetMakeModel;

                e.target.closest(".block__vehicle-lookup-input-box").querySelector('[data-search-vehicle-make-model]').value = makeModelValue;
                e.target.closest(".block__vehicle-lookup-input-box").querySelector('[data-search-vehicle-submit]').classList.remove("d-none");
            });
            container.appendChild(li);
        });
    }

    getUniqueCategories() {
        return [...new Set(Object.values(this.agricultureTurfJsonData)
            .map(item => item.equipment_category)
            .filter(Boolean))];
    }

    cacheElements() {
        const selectors = {
            makeModelInput: '[data-search-vehicle-make-model]',
            makeModelList: '[data-search-vehicle-make-model-list]',
            makeModelBox: '[data-selected-vehicle-make-model]',
            submitButton: '[data-search-vehicle-submit]',
            trimInput: '[data-search-vehicle-trim]',
            trimList: '[data-search-vehicle-trim-list]',
            trimBox: '[data-selected-vehicle-trim]',
            trimSubmitButton: '[data-search-vehicle-trim-submit]',
            trimBothSuggestionBox: '[data-trim-both-suggestion-box]',
            cabTypeInput: '[data-search-vehicle-cabType]',
            cabTypeList: '[data-search-vehicle-cabType-list]',
            cabTypeBox: '[data-selected-vehicle-cabType]',
            cabTypeSubmitButton: '[data-search-vehicle-cabType-submit]',
            cabTypeBothSuggestionBox: '[data-cabtype-both-suggestion-box]'
        };

        Object.entries(selectors).forEach(([key, selector]) => {
            this.elements[key] = this.querySelector(selector);
        });
    }

    bindEvents() {
        if (!this.elements.makeModelInput) return;

        this.bindSearchEvents();
        this.bindStepBackEvents();
    }

    bindSearchEvents() {
        const searchConfigs = [
            {
                input: this.elements.makeModelInput,
                list: this.elements.makeModelList,
                box: this.elements.makeModelBox,
                submit: this.elements.submitButton,
                handler: (e) => this.handleSearch(e, 'category', 3),
                selectionHandler: (e) => this.handleSelection(e, 'equipment_category'),
                submitHandler: (e) => this.handleSubmit(e, 'category')
            },
            {
                input: this.elements.trimInput,
                list: this.elements.trimList,
                box: this.elements.trimBox,
                submit: this.elements.trimSubmitButton,
                suggestionBox: this.elements.trimBothSuggestionBox,
                handler: (e) => this.handleSearch(e, 'manufacturer', 3),
                selectionHandler: (e) => this.handleSelection(e, 'equipment_manufacturer'),
                submitHandler: (e) => this.handleSubmit(e, 'manufacturer')
            },
            {
                input: this.elements.cabTypeInput,
                list: this.elements.cabTypeList,
                box: this.elements.cabTypeBox,
                submit: this.elements.cabTypeSubmitButton,
                suggestionBox: this.elements.cabTypeBothSuggestionBox,
                handler: (e) => this.handleSearch(e, 'model', 3),
                selectionHandler: (e) => this.handleSelection(e, 'equipment_model_number'),
                submitHandler: (e) => this.handleSubmit(e, 'model')
            }
        ];

        searchConfigs.forEach(config => this.bindSearchConfig(config));
    }

    bindSearchConfig(config) {
        if (!config.input) return;

        let debounceTimer;
        config.input.addEventListener('keyup', (e) => {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => config.handler(e), 150);
        });

        const clickTarget = config.suggestionBox || config.list;
        clickTarget?.addEventListener('click', config.selectionHandler);
        config.submit?.addEventListener('click', config.submitHandler);
    }

    bindStepBackEvents() {
        document.addEventListener('click', (e) => {
            const backButton = e.target.closest('[data-step-back-btn]');
            if (!backButton) return;

            e.preventDefault();
            const backStep = backButton.getAttribute('data-back-step');
            
            if (backStep && backStep !== '0') {
                this.navigateToPreviousStep(backButton, backStep);
            } else {
                backButton.closest('.block__vehicle-lookup-popup').classList.add('d-none');
            }
        });
    }

    navigateToPreviousStep(button, backStep) {
        const currentStep = button.closest('.block__vehicle-lookup-popup-details');
        const parentEle = currentStep.closest('.block__vehicle-lookup-popup-list');
        
        parentEle.querySelectorAll('.block__vehicle-lookup-popup-details')
            .forEach(step => this.hideElement(step));
            
        const previousStep = parentEle.querySelector(`[current-step="${backStep}"]`);
        if (previousStep) this.showElement(previousStep);
    }

    handleSearch(e, type, minLength) {
        const query = this.normalizeQuery(e.target.value);
        const config = this.getSearchConfig(type);

        if(query != ''){
            e.target.closest(".block__vehicle-lookup-input-box").classList.add("active-value");
        }else{
            e.target.closest(".block__vehicle-lookup-input-box").classList.remove("active-value");
        }
        
        this.toggleSubmitButton(config.submit, false);
        config.list.innerHTML = '';

        if (!query) {
            this.hideElement(config.box);
            return;
        }

        if (query.length >= minLength) {
            const matches = this.getMatches(type, query);
            this.populateResults(config.list, config.box, matches, type);
        } else {
            this.showMinLengthMessage(config.list, config.box, minLength, type);
        }
    }

    getSearchConfig(type) {
        const configs = {
            category: {
                list: this.elements.makeModelList,
                box: this.elements.makeModelBox,
                submit: this.elements.submitButton
            },
            manufacturer: {
                list: this.elements.trimList,
                box: this.elements.trimBox,
                submit: this.elements.trimSubmitButton
            },
            model: {
                list: this.elements.cabTypeList,
                box: this.elements.cabTypeBox,
                submit: this.elements.cabTypeSubmitButton
            }
        };
        return configs[type];
    }

    getMatches(type, query) {
        switch (type) {
            case 'category':
                // Enhanced search logic for makeModelInput
                return this.getCategoryMatches(query);
            case 'manufacturer':
                return this.getUniqueOptions('equipment_manufacturer', 
                    { equipment_category: this.selectedData.equipment_category })
                    .filter(man => String(man).toLowerCase().includes(query));
            case 'model':
                return this.getUniqueOptions('equipment_model_number', {
                    equipment_category: this.selectedData.equipment_category,
                    equipment_manufacturer: this.selectedData.equipment_manufacturer
                }).filter(model => String(model).toLowerCase().includes(query));
            default:
                return [];
        }
    }

    // Fixed method to handle enhanced category search
    getCategoryMatches(query) {
        const vehicleArray = Object.values(this.agricultureTurfJsonData);
        const results = [];

        // First, check if query matches any model numbers
        const modelMatches = vehicleArray.filter(item => 
            item.equipment_model_number && 
            String(item.equipment_model_number).toLowerCase().includes(query)
        );

        // Add model matches to results
        if (modelMatches.length > 0) {
            results.push(...modelMatches.map(item => ({
                displayText: `${item.equipment_category} ${item.equipment_manufacturer} ${item.equipment_model_number}`,
                equipment_category: item.equipment_category,
                equipment_manufacturer: item.equipment_manufacturer,
                equipment_model_number: item.equipment_model_number,
                isModelMatch: true
            })));
        }

        // Also check for category matches
        const categoryMatches = this.uniqueCategories
            .filter(cat => cat.toLowerCase().includes(query))
            .map(cat => ({
                displayText: cat,
                equipment_category: cat,
                equipment_manufacturer: '',
                equipment_model_number: '',
                isModelMatch: false
            }));

        // Add category matches to results
        results.push(...categoryMatches);

        // Remove duplicates based on displayText
        const uniqueResults = results.filter((item, index, self) => 
            index === self.findIndex(t => t.displayText === item.displayText)
        );

        return uniqueResults;
    }

    handleSelection(e, field) {
        const target = e.target;
        e.target.closest(".block__vehicle-lookup-input-box").classList.remove("active-value");
        
        // Enhanced selection handling for category field
        if (field === 'equipment_category') {
            const isModelMatch = target.getAttribute('data-vehicle-model-match') === 'true';
            
            if (isModelMatch) {
                // Handle model match selection - populate all three fields separately in selectedData
                const category = target.getAttribute('data-equipment-category') || target.getAttribute('data-vehicle-model-value') || '';
                const manufacturer = target.getAttribute('data-equipment-manufacturer') || target.getAttribute('data-vehicle-manufacturer-value') || '';
                const modelNumber = target.getAttribute('data-equipment-model-number') || target.getAttribute('data-vehicle-modelnumber-value') || '';
                
                // Store each field separately in selectedData (for localStorage)
                this.selectedData.equipment_category = String(category || '').trim();
                this.selectedData.equipment_manufacturer = String(manufacturer || '').trim();
                this.selectedData.equipment_model_number = String(modelNumber || '').trim();
                
                // Show combined display text in the input field (for UI display)
                const displayText = target.textContent || target.innerText || '';
                if (this.elements.makeModelInput) this.elements.makeModelInput.value = displayText.trim();
                
                // Update UI for category field
                if (this.elements.submitButton) this.toggleSubmitButton(this.elements.submitButton, true);
                if (this.elements.makeModelBox) this.hideElement(this.elements.makeModelBox);
                
                // Update selection state
                const container = target.closest('.block__vehicle-lookup-input-box');
                container?.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
                target.classList.add('selected');
                
                return;
            } else {
                // Handle regular category selection
                const categoryValue = target.getAttribute('data-vehicle-model-value')?.trim();
                if (categoryValue) {
                    this.selectedData.equipment_category = categoryValue;
                    // Reset other fields for category-only selection
                    this.selectedData.equipment_manufacturer = '';
                    this.selectedData.equipment_model_number = '';
                    
                    this.updateInputAndUI(target, categoryValue, field, false);
                    return;
                }
            }
        }

        const attributeMap = {
            equipment_category: 'data-vehicle-model-value',
            equipment_manufacturer: 'data-vehicle-trim-value',
            equipment_model_number: 'data-vehicle-cabType-value'
        };

        const attribute = attributeMap[field];
        if (!target.matches(`[${attribute}]`)) return;

        const selectedValue = target.getAttribute(attribute)?.trim();
        if (!selectedValue) return;

        this.selectedData[field] = selectedValue;
        this.updateInputAndUI(target, selectedValue, field);
    }

    handleSubmit(e, type) {
        e.preventDefault();
        
        if (type === 'model') {
            this.finalizeSelection();
        } else if (type === 'category') {
            // Check if this is a complete model match selection
            if (this.selectedData.equipment_category && 
                this.selectedData.equipment_manufacturer && 
                this.selectedData.equipment_model_number) {
                // Skip to final step since all data is selected
                this.finalizeSelection();
            } else {
                this.proceedToNextStep(e.target, type);
            }
        } else {
            this.proceedToNextStep(e.target, type);
        }
    }

    proceedToNextStep(element, type) {
        this.navigateToNextStep(element);
        
        if (type === 'category') {
            this.updateFinalDisplay('[data-show-final-selected-vehicle]', 
                this.selectedData.equipment_category);
            const matchingManufacturer = this.getUniqueOptions('equipment_manufacturer',{ equipment_category: this.selectedData.equipment_category }).slice(0, 5)
            this.populateSuggestions('[data-trim-suggestion]', matchingManufacturer, 'trim');
        } else if (type === 'manufacturer') {
            this.updateFinalDisplay('[data-selected-make-model-year-trim]', 
                `${this.selectedData.equipment_manufacturer} ${this.selectedData.equipment_category}`);

            const matchingModel = this.getUniqueOptions('equipment_model_number', { equipment_category: this.selectedData.equipment_category, equipment_manufacturer: this.selectedData.equipment_manufacturer }).slice(0, 5)

            this.populateSuggestions('[data-cabType-suggestion]', matchingModel, 'cabType');
        }
    }

    finalizeSelection() {
        document.querySelector(".block__vehicle-lookup-popup:not(.d-none) .block__vehicle-lookup-popup-details:not(.d-none)").querySelector(".block__vehicle-lookup-input-button").classList.add("loading");
        
        // Always use separate values from selectedData to ensure they are stored separately in localStorage
        const equipment_category = String(this.selectedData.equipment_category || '').trim();
        const equipment_manufacturer = String(this.selectedData.equipment_manufacturer || '').trim();
        const equipment_model_number = String(this.selectedData.equipment_model_number || '').trim();
        
        // Get display labels - always use separate values from selectedData for localStorage
        // The input field shows combined text (for UI display), but localStorage stores separate values
        // Always prefer selectedData values (which are separate) over input values
        const categoryLabel = equipment_category;
        const manufacturerLabel = equipment_manufacturer;
        const modelLabel = equipment_model_number;
        
        if (!this.checkIfVehicleExists(equipment_category, equipment_manufacturer, equipment_model_number)) {
            const vehicleData = this.createVehicleData(equipment_category, equipment_manufacturer, equipment_model_number);
            const vehicleLabels = this.createVehicleLabels(vehicleData.id, categoryLabel, manufacturerLabel, modelLabel);
            this.addVehicleToSelection(vehicleData, vehicleLabels);
        } else {
            // Vehicle exists - find it, set as default, and update currentSelectedData
            const existingVehicle = window.customerSelectedVehicles.turf.find(vehicle =>
                vehicle.equipment_category === equipment_category &&
                vehicle.equipment_manufacturer === equipment_manufacturer &&
                vehicle.equipment_model_number === equipment_model_number
            );
            
            if (existingVehicle) {
                // Reset all defaults first
                this.resetAllVehicleDefaults();
                // Set this vehicle as default
                existingVehicle.default = true;
                
                // Ensure existing vehicle has separate fields stored
                existingVehicle.equipment_category = String(equipment_category || '').trim();
                existingVehicle.equipment_manufacturer = String(equipment_manufacturer || '').trim();
                existingVehicle.equipment_model_number = String(equipment_model_number || '').trim();
                
                // Create labels for currentSelectedDataLabels - each field stored separately
                const vehicleLabels = this.createVehicleLabels(existingVehicle.id, categoryLabel, manufacturerLabel, modelLabel);
                this.updateCurrentSelectedData(existingVehicle, vehicleLabels);
                
                // Update localStorage
                const isCustomer = document.body.classList.contains('customer-loggedin');
                if (isCustomer && window.shopifyFormUtility) {
                    localStorage.removeItem('turf_data');
                } else {
                    localStorage.setItem('turf_data', JSON.stringify(window.customerSelectedVehicles.turf));
                }
            }
        }

        const partNumbers = this.getPartNumbers(equipment_category, equipment_manufacturer, equipment_model_number);
        this.redirectToResults(partNumbers);
    }

    // Utility methods
    normalizeQuery(value) {
        return value.toLowerCase().replace(/\s+/g, ' ').trim();
    }

    populateResults(container, resultBox, matches, type) {
        this.showElement(resultBox);
        
        if (matches.length > 0) {
            if (type === 'category' && matches[0].isModelMatch !== undefined) {
                // Handle enhanced category results
                container.innerHTML = matches.map(match => 
                    this.createEnhancedListItem(match)
                ).join('');
            } else {
                // Handle regular results
                const attributeMap = {
                    category: 'data-vehicle-model-value',
                    manufacturer: 'data-vehicle-trim-value',
                    model: 'data-vehicle-cabType-value'
                };
                
                container.innerHTML = matches.map(match => 
                    this.createListItem(match, { [attributeMap[type]]: match })
                ).join('');
            }
        } else {
            container.innerHTML = '<li class="data-vehicle-model-list">No results found</li>';
        }
    }

    // Method to create enhanced list items for combined results
    createEnhancedListItem(match) {
        if (match.isModelMatch) {
            // Store each field separately in data attributes
            const attrs = {
                'data-vehicle-model-value': match.equipment_category || '',
                'data-vehicle-manufacturer-value': match.equipment_manufacturer || '',
                'data-vehicle-modelnumber-value': match.equipment_model_number || '',
                'data-equipment-category': match.equipment_category || '',
                'data-equipment-manufacturer': match.equipment_manufacturer || '',
                'data-equipment-model-number': match.equipment_model_number || '',
                'data-vehicle-model-match': 'true',
                'class': 'data-vehicle-model-list'
            };
            
            return this.createListItem(match.displayText, attrs);
        } else {
            // For category matches, ensure proper attributes are set
            return this.createListItem(match.displayText, {
                'data-vehicle-model-value': match.equipment_category || '',
                'data-equipment-category': match.equipment_category || '',
                'data-equipment-manufacturer': '',
                'data-equipment-model-number': '',
                'data-vehicle-model-match': 'false',
                'class': 'data-vehicle-model-list'
            });
        }
    }

    showMinLengthMessage(container, box, minLength, type) {
        this.showElement(box);
        const equipmentType = type === 'category' ? 'Heavy Equipment' : 
                            type === 'manufacturer' ? 'manufacturer' : 'model';
        container.innerHTML = `<li class="data-vehicle-model-list">Please enter at least ${minLength} characters of the ${equipmentType}.</li>`;
    }

    populateSuggestions(selector, items, type) {
        const container = this.querySelector(selector);
        const suggestionBox = this.querySelector(`[data-${type}-suggestion-box]`);
        
        if (!container || !suggestionBox) return;
        
        this.showElement(suggestionBox);
        container.innerHTML = items.map(item => 
            this.createListItem(item, {
                [`data-${type}-value`]: '',
                [`data-vehicle-${type}-value`]: item,
                class: 'block__vehicle-lookup-input-result-li'
            })
        ).join('');
    }

    createElement(tag, textContent, attributes = {}) {
        const element = document.createElement(tag);
        if (textContent) element.textContent = textContent;
        
        Object.entries(attributes).forEach(([key, value]) => {
            if (key === 'class') {
                element.className = value;
            } else {
                element.setAttribute(key, value);
            }
        });
        
        return element;
    }

    updateInputAndUI(targetElement, value, field, isModelMatch = false) {
        const inputMap = {
            equipment_category: this.elements.makeModelInput,
            equipment_manufacturer: this.elements.trimInput,
            equipment_model_number: this.elements.cabTypeInput
        };
        
        const submitMap = {
            equipment_category: this.elements.submitButton,
            equipment_manufacturer: this.elements.trimSubmitButton,
            equipment_model_number: this.elements.cabTypeSubmitButton
        };
        
        const boxMap = {
            equipment_category: this.elements.makeModelBox,
            equipment_manufacturer: this.elements.trimBox,
            equipment_model_number: this.elements.cabTypeBox
        };

        const input = inputMap[field];
        const submit = submitMap[field];
        const box = boxMap[field];

        if (input) input.value = value;
        if (submit) this.toggleSubmitButton(submit, true);
        if (box) this.hideElement(box);

        // Update selection state
        const container = targetElement.closest('.block__vehicle-lookup-input-box');
        container?.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
        targetElement.classList.add('selected');

        // If this is a model match, you can add styling or other indicators if needed
        // (submit button text remains unchanged)
    }

    navigateToNextStep(element) {
        const currentStep = element.closest('.block__vehicle-lookup-popup-details');
        const nextStepIndex = currentStep.getAttribute('data-next-step');
        const parentEle = currentStep.closest('.block__vehicle-lookup-popup-list');
        
        parentEle.querySelectorAll('.block__vehicle-lookup-popup-details')
            .forEach(step => this.hideElement(step));
        
        const nextStep = parentEle.querySelector(`[current-step="${nextStepIndex}"]`);
        if (nextStep) this.showElement(nextStep);
    }

    updateFinalDisplay(selector, content) {
        const element = this.querySelector(selector);
        if (element) element.innerHTML = content;
    }

    checkIfVehicleExists(equipment_category, equipment_manufacturer, equipment_model_number) {
        return window.customerSelectedVehicles?.turf?.some(vehicle =>
            vehicle.equipment_category === equipment_category &&
            vehicle.equipment_manufacturer === equipment_manufacturer &&
            vehicle.equipment_model_number === equipment_model_number
        ) || false;
    }

    createVehicleData(equipment_category, equipment_manufacturer, equipment_model_number) {
        // Store each field separately in localStorage
        return {
            id: Math.floor(Math.random() * 4000) + 1000,
            equipment_category: String(equipment_category || '').trim(),
            equipment_manufacturer: String(equipment_manufacturer || '').trim(),
            equipment_model_number: String(equipment_model_number || '').trim(),
            default: false
        };
    }

    createVehicleLabels(id, categoryLabel, manufacturerLabel, modelLabel) {
        // Store each field separately in localStorage labels
        return {
            id: id,
            equipment_category: String(categoryLabel || '').trim(),
            equipment_manufacturer: String(manufacturerLabel || '').trim(),
            equipment_model_number: String(modelLabel || '').trim(),
            default: true
        };
    }

    addVehicleToSelection(vehicleData, vehicleLabels) {
        const isCustomer = document.body.classList.contains('customer-loggedin');
        
        // Reset all defaults first
        this.resetAllVehicleDefaults();
        
        // Set default to true for the new vehicle
        vehicleData.default = true;
        
        // Add the new vehicle with default: true
        // vehicleData contains separate fields: equipment_category, equipment_manufacturer, equipment_model_number
        window.customerSelectedVehicles.turf.push(vehicleData);
        
        // Update currentSelectedData and currentSelectedDataLabels with the new vehicle
        // Both contain separate fields stored individually
        this.updateCurrentSelectedData(vehicleData, vehicleLabels);

        if (isCustomer && window.shopifyFormUtility) {
            localStorage.removeItem('turf_data');
        } else {
            // Store in localStorage - each field stored separately in the array
            localStorage.setItem('turf_data', JSON.stringify(window.customerSelectedVehicles.turf));
        }
    }

    updateCurrentSelectedData(vehicleData, vehicleLabels) {
        // Update currentSelectedData with raw values - each field stored separately
        // vehicleData contains: equipment_category, equipment_manufacturer, equipment_model_number
        localStorage.setItem('currentSelectedData', JSON.stringify(vehicleData));
        // Update currentSelectedDataLabels with display labels - each field stored separately
        // vehicleLabels contains: equipment_category, equipment_manufacturer, equipment_model_number
        localStorage.setItem('currentSelectedDataLabels', JSON.stringify(vehicleLabels));
    }

    resetAllVehicleDefaults() {
        // Reset all default values to false across all localStorage keys
        const storageKeys = ['vehicle_data_side', 'vehicle_data_sahdt', 'vehicle_data', 'turf_data', 'heavy_equipment_data'];
        
        storageKeys.forEach(key => {
            const storedData = localStorage.getItem(key);
            if (storedData) {
                try {
                    const vehicles = JSON.parse(storedData);
                    if (Array.isArray(vehicles)) {
                        // Set all vehicles' default to false
                        vehicles.forEach(vehicle => {
                            vehicle.default = false;
                        });
                        // Update localStorage with modified data
                        localStorage.setItem(key, JSON.stringify(vehicles));
                    }
                } catch (error) {
                    console.error(`Error processing ${key}:`, error);
                }
            }
        });
        
        // Also update window.customerSelectedVehicles if it exists
        if (window.customerSelectedVehicles) {
            const vehicleTypes = ['side', 'sahdt', 'vehicle', 'turf', 'heavyEquipment'];
            vehicleTypes.forEach(type => {
                if (window.customerSelectedVehicles[type] && Array.isArray(window.customerSelectedVehicles[type])) {
                    window.customerSelectedVehicles[type].forEach(vehicle => {
                        vehicle.default = false;
                    });
                }
            });
        }
    }

    getPartNumbers(equipment_category, equipment_manufacturer, equipment_model_number) {
        const vehicleArray = Object.values(this.agricultureTurfJsonData);
        const filteredVehicles = vehicleArray.filter(item => 
            String(item.equipment_category || '').toLowerCase() === String(equipment_category || '').toLowerCase() &&
            String(item.equipment_manufacturer || '').toLowerCase() === String(equipment_manufacturer || '').toLowerCase() &&
            String(item.equipment_model_number || '').toLowerCase() === String(equipment_model_number || '').toLowerCase()
        );

        const uniquePartNumbers = [...new Set(
            filteredVehicles
                .map(item => item.equipment_part_number)
                .filter(Boolean)
        )];
        
        return uniquePartNumbers.map(p => `sku-${p}`).join(',');
    }

    redirectToResults(partNumbers) {
        const isCustomer = document.body.classList.contains('customer-loggedin');
        
        if (isCustomer && window.shopifyFormUtility) {
            shopifyFormUtility._updateCustomerTurfMeta(window.customerSelectedVehicles.turf, partNumbers);
        } else {
            window.location.href = `/collections/all?filter.p.tag=${partNumbers}`;
        }
    }

    getUniqueOptions(field, filters) {
        const vehicleArray = Object.values(this.agricultureTurfJsonData);
        
        const matching = vehicleArray
            .filter(v => 
                Object.entries(filters).every(([key, value]) => 
                    String(v[key] || '').toLowerCase() === String(value || '').toLowerCase()
                )
            )
            .map(v => v[field])
            .filter(Boolean);
        
        return [...new Set(matching)];
    }

    // DOM utility methods
    createListItem(content, attributes = {}) {
        const attrs = Object.entries({
            ...attributes,
            class: attributes.class || 'data-vehicle-model-list'
        }).map(([k, v]) => `${k}="${v}"`).join(' ');
        
        return `<li ${attrs}>${content}</li>`;
    }

    showElement(element) {
        element?.classList.remove('d-none');
    }

    hideElement(element) {
        element?.classList.add('d-none');
    }

    toggleSubmitButton(button, show) {
        if (!button) return;
        button.classList.toggle('d-none', !show);
    }
}

customElements.define('agriculture-turf-shop', AgricultureTurfShop);